var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.475 0H2.41C1.117 0 .066 1.041.066 2.321V16.25c0 1.28 1.051 2.321 2.344 2.321h7.033v-6.384H7.098V9.287h2.345V6.964c0-1.923 1.574-3.482 3.516-3.482h2.344v2.902h-1.172c-.647 0-1.172-.06-1.172.58v2.322h2.93l-1.172 2.902H12.96v6.383h3.516c1.293 0 2.345-1.04 2.345-2.321V2.321C18.82 1.041 17.768 0 16.475 0z"}));
}

Facebook.defaultProps = {"viewBox":"0 0 19 19"};

module.exports = Facebook;

Facebook.default = Facebook;
